export enum ImgLoading {
  EAGER = 'eager',
  LAZY = 'lazy',
}

export enum ImgDecoding {
  SYNC = 'sync',
  ASYNC = 'async',
  AUTO = 'auto',
}
